import logoUrl from '../../assets/brand/mlp-logo.svg?no-inline';
import { Image } from '../../ui';
import { RADIUS } from '../../ui/theme/tokens';

/**
 * My Lifestyle Platform's logo on its white ground, rounded: the app icon's
 * drawing, cropped closer, because the app icon keeps the padding a maskable
 * icon needs.
 *
 * `alt=""` by default, because everywhere it is used the platform's name is
 * written beside it; pass `label` where it stands alone.
 */
export function BrandMark({ size, label = '' }: { size: number; label?: string }) {
  return (
    <Image
      src={logoUrl}
      alt={label}
      styles={{ display: 'block', width: size, height: size, flexShrink: 0, borderRadius: `${RADIUS.md}px` }}
    />
  );
}
